/**
 * Feature Flag Definitions
 *
 * This file contains all feature flags used throughout the Soteria application.
 */

export const FEATURE_FLAGS = {
  NOTIFICATIONS: 'NOTIFICATIONS',
  COMMUNITY_GROUP_OBJECTS: 'COMMUNITY_GROUP_OBJECTS',
  MODERATION: 'MODERATION',
  CALLBACK_AUTHENTICATION: 'CALLBACK_AUTHENTICATION',
  SECURITY_GROUPS: 'SECURITY_GROUPS',
  AUTHENTICATION_PROVIDERS: 'AUTHENTICATION_PROVIDERS',
  USERNAME_CLASSIFICATION: 'USERNAME_CLASSIFICATION',
  STRIKE: 'STRIKE',
  COMMUNITY_OVERVIEW: 'COMMUNITY_OVERVIEW',
  CASE_SEARCH: 'CASE_SEARCH',
  COMMUNITY_HEADER_V2: 'COMMUNITY_HEADER_V2',
  ACTION_ADVANCED_SETTINGS: 'ACTION_ADVANCED_SETTINGS',
  CLASSIFICATION_DIALOG_V2: 'CLASSIFICATION_DIALOG_V2',
  HIDE_MODERATION_STATS_CARDS: 'HIDE_MODERATION_STATS_CARDS',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

/**
 * Feature Flag Display Names
 *
 * Maps feature flag keys to user-friendly display names for the UI.
 * If a feature flag is not defined here, the flag string will be used as fallback.
 */
export const FEATURE_FLAG_DISPLAY_NAMES: Record<FeatureFlag, string> = {
  [FEATURE_FLAGS.NOTIFICATIONS]: 'Notifications',
  [FEATURE_FLAGS.COMMUNITY_GROUP_OBJECTS]: 'Community Group Objects',
  [FEATURE_FLAGS.MODERATION]: 'Moderation',
  [FEATURE_FLAGS.CALLBACK_AUTHENTICATION]: 'Callback Authentication',
  [FEATURE_FLAGS.SECURITY_GROUPS]: 'Security Groups',
  [FEATURE_FLAGS.AUTHENTICATION_PROVIDERS]: 'Authentication Providers',
  [FEATURE_FLAGS.USERNAME_CLASSIFICATION]: 'Username Classification',
  [FEATURE_FLAGS.STRIKE]: 'Strike',
  [FEATURE_FLAGS.COMMUNITY_OVERVIEW]: 'Community Overview Tab',
  [FEATURE_FLAGS.CASE_SEARCH]: 'Case Search',
  [FEATURE_FLAGS.COMMUNITY_HEADER_V2]: 'Community Header V2',
  [FEATURE_FLAGS.ACTION_ADVANCED_SETTINGS]: 'Action Advanced Settings (JSON Payload & Operator Name)',
  [FEATURE_FLAGS.CLASSIFICATION_DIALOG_V2]: 'Classification Dialog V2 (Wide Layout)',
  [FEATURE_FLAGS.HIDE_MODERATION_STATS_CARDS]: 'Hide Moderation Stats Cards',
} as const;

/**
 * Get the display name for a feature flag
 * @param featureFlag - The feature flag to get the display name for
 * @returns The display name if defined, otherwise the feature flag string
 */
export function getFeatureFlagDisplayName(featureFlag: FeatureFlag): string {
  return FEATURE_FLAG_DISPLAY_NAMES[featureFlag] || featureFlag;
}
